export default (state, action) => ({
  ...state,
  expandedItems: action.payload.items,
});
